import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false;

// 引入组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/scss/element-variables.scss';
// import locale from 'element-ui/lib/locale/lang/en';

import i18n from "./i18n/index.js"

Vue.prototype.i18n = i18n;
// Vue.use(ElementUI, { locale })
Vue.use(ElementUI);

// 全局message封装
import {showMessage} from './utils/message.js';
Vue.prototype.showMessage = showMessage;

// 全局vue-clipboard2封装
import VueClipBoard from "vue-clipboard2";
Vue.use(VueClipBoard);

// 全局date封装,转换日期格式
import {formatDate} from './utils/date.js';
import {compareDate} from './utils/date.js';

Vue.prototype.formatDate = formatDate;
Vue.prototype.compareDate = compareDate;

// 全局number封装,转换数字格式
import {formatNumber,formatUpper,validateSingleLineCharLength,convertCurrency,formatUpperNoChinese} from './utils/formatInput.js';

Vue.prototype.formatNumber = formatNumber;
Vue.prototype.formatUpper = formatUpper;
Vue.prototype.validateSingleLineCharLength = validateSingleLineCharLength;
Vue.prototype.convertCurrency = convertCurrency;
Vue.prototype.formatUpperNoChinese = formatUpperNoChinese;

import Watermark from "./utils/waterMark.js";
Vue.prototype.Watermark = Watermark;

// 全局axios封装
import axios from 'axios';
import { getCurrentEntity, getApiPrefix, clearEntityStatus } from './utils/apiUtils.js';
import * as apiUtils from './utils/apiUtils.js';

Vue.prototype.axios = axios;
Vue.prototype.$apiUtils = apiUtils;

// 添加axios请求拦截器，动态设置API前缀
axios.interceptors.request.use(
    config => {
        // 获取当前主体信息
        const entity = getCurrentEntity();
        console.log("当前主体：", entity);

        // 如果URL以/api/开头，则根据主体替换前缀
        if (config.url && config.url.startsWith('/api/')) {
            if (!entity) {
                // 主体未获取到，清理状态并跳转到首页
                clearEntityStatus();
                sessionStorage.setItem("ACCOUNT_CODE", "");
                sessionStorage.setItem("COMPANY_CODE", "");
                sessionStorage.removeItem("permissionList");
                
                // 跳转到首页
                if (window.location.pathname !== '/') {
                    window.location.href = '/';
                }
                
                return Promise.reject(new Error('主体未选择，请重新登录'));
            }
            
            // 获取API前缀并替换URL
            const prefix = getApiPrefix();
            config.url = config.url.replace('/api/', prefix);
            console.log("请求地址：",config.url);
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel);

// 自定义文字提示组件
import descriptionsTooltip from './components/descriptionsTooltip';
Vue.component('descriptionsTooltip',descriptionsTooltip);


import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
VXETable.setup({
    // 对组件内置的提示语进行国际化翻译
    i18n: (key, args) => i18n.t(key, args),
    // 可选，i18n自定义部分，对参数中的列头、校验提示..等进行自动翻译
    translate(key, args) {
        return i18n.t(key, args)
    }
});
Vue.use(VXETable);
//如果用不到这个组件的弹窗可以不写，根据个人使用情况而定
Vue.prototype.$XModal = VXETable.modal;


// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
    if(sessionStorage.getItem("permissionList") == null || sessionStorage.getItem("ACCOUNT_CODE") === "") {
        // 获取用户权限数据缓存到session和vuex中
        axios({
            method: 'post',
            url: '/api/elineFunction/getAllFunctionByLoginUser',
            headers: {
                'Content-type': 'application/json',
                'Accept-language': localStorage.getItem("locale")
            }
        }).then(response => {
            if (response.data.backCode === "200") {
                // 获取成功,将功能权限信息缓存到session中
                sessionStorage.setItem("permissionList",JSON.stringify(response.data.object));
                // 将功能权限信息缓存到vuex中
                store.state.permissionList = response.data.object;
            }
        }).catch(error => {
            if (error.data) {
                this.responseCode = error.data.backMessage;
                showMessage(false, this.responseCode, "error");
            } else {
                showMessage(false, error, "error");
            }
        });
    } else{
        // vuex中的状态一旦页面刷新，就不再存在，需要从sessionStorage种提取状态再传值给vuex
        store.state.permissionList = JSON.parse(sessionStorage.getItem("permissionList"));
    }

    if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
        //重新获取登录用户信息
        Vue.prototype.axios({
            method: 'post',
            url: '/api/user/getLoginInfo',
            headers: {
                'Content-type': 'application/json',
                'Accept-language': localStorage.getItem("locale")
            }
        }).then(response => {
            if (response.data.backCode === "200" && response.data.object.customerName) {//当前页面需要登录且已经登录,直接去到页面
                next();
                sessionStorage.setItem("ACCOUNT_CODE", response.data.object.customerName === null ?
                    "" : response.data.object.customerName.toString());
                sessionStorage.setItem("COMPANY_CODE", response.data.object.companyNameCn === null ?
                    "" : response.data.object.companyNameCn.toString());
                let customer = {};
                customer.companyCode = response.data.object.companyCode === null ?
                    "" : response.data.object.companyCode.toString();
                customer.companyName = response.data.object.companyName === null ?
                    "" : response.data.object.companyName.toString();
                customer.companyNameCn = response.data.object.companyNameCn === null ?
                    "" : response.data.object.companyNameCn.toString();
                customer.countryCode = response.data.object.countryCode === null ?
                    "" : response.data.object.countryCode;
                customer.electronicInvoiceFlag = response.data.object.electronicInvoiceFlag === null ?
                    "" : response.data.object.electronicInvoiceFlag;
                sessionStorage.setItem("CUSTOMER", JSON.stringify(customer));
            } else {//当前页面需要登录但是没有登录,先去首页登录
                // 清空session中的账号信息
                sessionStorage.setItem("ACCOUNT_CODE", "");
                sessionStorage.setItem("COMPANY_CODE", "");
                apiUtils.clearEntityStatus();
                ElementUI.Message({
                    message: i18n.t("message.loginFirst"),
                    type: 'warning'
                });
                next({
                    path: '/',
                    query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        }).catch(error => {
            if (error.data) {
                this.responseCode = error.data.backMessage;
                showMessage(false, this.responseCode, "error");
            } else {
                showMessage(false, error, "error");
            }
        });
        // console.log(!sessionStorage.getItem("ACCOUNT_CODE"));
        // console.log(sessionStorage.getItem("ACCOUNT_CODE") === "");
        // console.log(sessionStorage.getItem("ACCOUNT_CODE"));
    } else {
        next();
    }
});

new Vue({
    router,
    store,
    render: h => h(App),
    i18n
}).$mount('#app');

var head = document.getElementsByTagName('head')[0];
var script = document.createElement('script');
var url = "http://coreapi.zhonggu56.com/api/changecolor/getcolor?systemName=电商";
script.setAttribute('type', 'text/javascript');
script.setAttribute('src', url);
head.appendChild(script);
//加载成功
var onLoadSuccess = () => {

};
if (document.all) { //IE
    script.onreadystatechange = function () {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
            onLoadSuccess();
        }
    }
} else {
    script.onload = function () {
        onLoadSuccess();
    }
}

// 注册一个全局自定义指令 `v-upper`,用于将input输入的内容自动转换成全大写
Vue.directive('upper', {
    inserted: function (el) {
        const inputNode = el.getElementsByTagName("input")[0];
        // 获取转换前的值
        let value = inputNode.value.toUpperCase();
        console.log("传入值：",inputNode.value);
        inputNode.oninput = (event)=>{
            inputNode.value = value;
            console.log("input:",value);
        };
        inputNode.onchange = (event)=>{
            inputNode.value = value;
            console.log("change:",inputNode.value);
        };
    },
    componentUpdated: function (el) {
        const inputNode = el.getElementsByTagName("input")[0];
        // 获取转换前的值
        let value = inputNode.value.toUpperCase();
        console.log("传入值：",inputNode.value);
        inputNode.oninput = (event)=>{
            inputNode.value = value;
            console.log("input:",value);
        };
        inputNode.onchange = (event)=>{
            inputNode.value = value;
            console.log("change:",inputNode.value);
        };
    }
});
